import React, { useState} from "react";
import { BreadcrumbPage } from "../../shared";
import Button from '@mui/material/Button';
import Grid from "@material-ui/core/Grid";
import { Box } from "@material-ui/core";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CancelIcon from '@mui/icons-material/Cancel';
import ClearIcon from '@mui/icons-material/Clear';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import DownloadIcon from '@mui/icons-material/Download';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import ctrl from '../Helpsection_images/ctrl.jpg';
import clear from '../Helpsection_images/clear.jpg';
import cancel from '../Helpsection_images/cancel.jpg';
import applyfilter from '../Helpsection_images/applyfilter.jpg';
import reset from '../Helpsection_images/reset.jpg';
import Help from "@material-ui/icons/Help";
import Fluid_Quality from '../Helpsection_images/Fluid_Quality.jpg';
import Gas_Quality from '../Helpsection_images/Gas_Quality.jpg';
import Insulating_Paper_Quality from '../Helpsection_images/Insulating_Paper_Quality.jpg';
import Environmental_Assessment from '../Helpsection_images/Environment_Assessment.jpg';
import AssetList from '../Helpsection_images/AssetList.jpg';
import transformer_assestclear from '../Helpsection_images/transformer_assestclear.jpg';
import transformer_assest from '../Helpsection_images/transformer_assest.jpg';

export default function TrendsHelp(){
    const BreadcrumbList = [{ name: "Trends", url: "" }];
    const [openform, setOpenform] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpenForm = () => {
        setOpenform(true);
    };
    const handleClickClose = () => {
        setOpenform(false);
    };

    return(
        <Grid className="breadcrum trends" item xs={12}>
        <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpenForm} />} />
        <Box component="div" className="pos_relative">
            <Dialog
                open={openform}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title" color="white">Trends</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}
                    >
                        <p className="subtitle">Help On Filter Panel</p><br />
                        <img className="maxwidth100" src="/assets/images/Trends_page_Transformer_help_section1.jpg"></img><br /><br />
                        <p>
                            <li>Click and type on the fields to see the options</li><br />
                            <li>For multiple selections hold <img src={ctrl} width="40px" height="40px" /> to select options from the list</li><br />
                            <li>Click <CheckBoxOutlineBlankIcon/> to see Historic and Current Vessels </li><br/>
                            <li>Click <ClearIcon color="disabled" /> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px" /></li><br />
                            <li>Click <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /> </li><br />
                            <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected filters</li><br />
                            <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                            <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                        </p><br />
                        <p className="subtitle">Help On Transformer Update Chart</p><br />
                        <img className="maxwidth100" src="/assets/images/Trends_page_Transformer_Help_Section2.jpg"></img>
                        <img className="maxwidth100" src="/assets/images/Trends_page_Transformer_Help_Section3.jpg"></img><br /><br />
                        <p>
                            <li>Select transformers from transformer list in left corner</li><br/>
                            <li>And can select multiple transformer at the same time from the list <img src={AssetList} alt="" width="120px" height="120px" /></li><br />
                            <li>Selected transformer will display on the top as the list <img src={transformer_assest} alt="" width="300px" height="300px" /></li><br />
                            <li>Click <ClearIcon color="disabled" /> to remove individual selection in the list <img src={transformer_assestclear} alt="" width="300px" height="300px" /></li><br />
                            <li>Select any check box(Multiple Selection) in Fulid Quality section <img src={Fluid_Quality} alt="" width="300px" height="300px" /></li><br />
                            <li>Select any check box(Multiple Selection) in Gas Quality section <img src={Gas_Quality} alt="" width="300px" height="300px" /></li><br />
                            <li>Select any check box(Multiple Selection) in Insulating Paper Quality section <img src={Insulating_Paper_Quality} alt="" width="300px" height="300px" /></li><br />
                            <li>Select any check box(Multiple Selection) in Environmental Assessment<img src={Environmental_Assessment} alt="" width="300px" height="300px" /></li><br />
                            <li>Chart will display in each section related selected check box and transformer details</li><br />
                            <li>Click on the <ZoomOutMapIcon /> will expand the section and will display only that section</li><br />
                            <li>Click <DownloadIcon/> icon will export the particular chart data in excel</li><br/>
                            <li>Click on the <CancelIcon color="primary" /> will close the expanded section</li><br />
                            <li>Click on the dots will open the PDF in another tab ,If there is no pdf(data) will not open</li><br />
                        </p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    </Grid>
    )
}